<template>
  <div class="head-wrap">
    <div style="float:right;margin:-14px 15px 0 0">
      <user-info />
    </div>
    <a-form layout="inline" class="actions">
      <a-form-item>
        <a-space>
          <a-button icon="picture" @click="showGallery">图库</a-button>
          <a-button icon="save" type="primary" @click="save" :loading="saving">保存</a-button>
        </a-space>
      </a-form-item>
      <span class="mr20"></span>

      <!-- 对齐 -->
      <a-form-item>
        <a-tooltip title="框选" class="mr10">
          <a-button @click="switchCrop"><icon-font type="icon-crop" /></a-button>
        </a-tooltip>
        <a-button-group >
          <a-tooltip title="垂直居中">
            <a-button icon="pic-center" @click="setAlignment('middle')"></a-button>
          </a-tooltip>
          <a-tooltip title="水平居中">
            <a-button icon="align-center" @click="setAlignment('center')"></a-button>
          </a-tooltip>
        </a-button-group>
      </a-form-item>
      <a-form-item>
        <a-button @click="$emit('preview')">预览</a-button>
      </a-form-item>
      <a-form-item>
        <a-button
          icon="shopping-cart"
          :loading="applying"
          @click="submit"
        >提交生产</a-button>
      </a-form-item>
      <a-form-item label="单号" style="color:#fff;">{{orderInfo.orderId}}
        <a-button type="link" @click="showModifyOrderInfo">
          <a-icon type="edit"></a-icon>
        </a-button>
        <a-button ghost @click="close">关闭</a-button>
      </a-form-item>
    </a-form>

    <!-- 图库 -->
    <PickPicture ref="pickPicture" @choosePicture="choosePicture"/>

    <!-- 修改单号 -->
    <a-modal
      size="small"
      title="订单编号"
      ok-text='确定'
      cancel-text='取消'
      v-model="modifyOrderIdVisible"
      @ok="modifyOrderIdOk"
      @cancel="modifyOrderIdCancel"
    >
      <a-form-model ref="modifyOrderForm" :model="eOrderInfo" :rules="orderInfoRules">
        <a-form-model-item prop="orderId">
          <a-input v-model.trim="eOrderInfo.orderId" placeholder="订单编号"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import projectModel from '@/api/project'
import PickPicture from './PickPicture.vue'
import userInfo from '../home/UserInfo'
import { Icon } from 'ant-design-vue'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: 'static/iconfont/iconfont.js'
})

export default {
  components: {
    IconFont,
    PickPicture,
    userInfo
  },
  props: ['orderId', 'projectId'],
  data () {
    return {
      // 订单信息
      orderInfo: {
        orderId: this.orderId
      },
      eOrderInfo: {},
      modifyOrderIdVisible: false,
      orderInfoRules: {
        orderId: [{required: true,
          trigger: 'blur',
          validator: async (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请填写订单号'))
            }
            this.orderIdValidating = true
            try {
              const res = await projectModel.search(value)
              if (res.data && res.data.id !== this.projectId) {
                console.log(2222, res.data.id, this.projectId)
                return callback(new Error('订单号已存在, 不能填写重复的订单号'))
              }
              return callback()
            } finally {
              this.orderIdValidating = false
            }
          }}]
      },
      // 保存
      saving: false,
      // 提交生产
      applying: false,
      // 修改订单号
      orderIdValidating: false
    }
  },
  computed: {
  },
  created () {

  },
  methods: {
    showGallery (ev) {
      this.$refs.pickPicture.show()
    },
    // 设置居中
    // type: center / middle
    setAlignment (type) {
      this.$emit('setAlignment', type)
    },
    choosePicture (param) {
      this.$emit('choosePicture', param)
    },
    // 显示/隐藏截图框
    switchCrop () {
      this.$emit('switch-crop')
    },
    save () {
      this.$emit('save')
    },
    // 提交
    submit () {
      this.$emit('submit')
    },
    // 关闭
    close () {
      this.$emit('close')
    },
    // 修改订单 编号
    showModifyOrderInfo () {
      this.eOrderInfo = JSON.parse(JSON.stringify(this.orderInfo))
      this.modifyOrderIdVisible = true
      this.$nextTick(_ => {
        this.$refs.modifyOrderForm.validate()
      })
    },
    modifyOrderIdOk () {
      this.$refs.modifyOrderForm.validate(valid => {
        if (valid) {
          this.orderInfo = this.eOrderInfo
          this.$emit('modify-order-info', this.orderInfo)
          this.modifyOrderIdVisible = false
        }
      })
    },
    modifyOrderIdCancel () {
      this.modifyOrderIdVisible = false
    }
  }
}
</script>

<style>
.head-wrap .actions{margin-top:12px;}
.head-wrap .actions label{color:#fff;}
</style>



// WEBPACK FOOTER //
// src/pages/design/Head.vue